// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
import createReducer from '../../../../../../../store/createReducer';
import * as types from './actionTypes';

const initialState = {
  loading: false,
  voucher: {},
};

const voucherDetailsReducer = createReducer(initialState, {
  [types.VOUCHER_DETAILS_START_LOADER](state) {
    return {
      ...state,
      loading: true,
    };
  },
  [types.VOUCHER_DETAILS_STOP_LOADER](state) {
    return {
      ...state,
      loading: false,
    };
  },
  [types.VOUCHER_DETAILS_GET_VOUCHER_SUCCESS](state, action) {
    return {
      ...state,
      voucher: action.payload
    };
  }
});

export default voucherDetailsReducer;
